//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionBuilder.js";
import "../no/SelectNXObjectList.js";
import "../Motion/Motion.LinkAttachmentData.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"AnalyticalContacts",0,"SelectNXObjectList",0],[1,"Attachment",0,"Motion.LinkAttachmentData",0],[1,"BeamForces",0,"SelectNXObjectList",0],[1,"Bushings",0,"SelectNXObjectList",0],[1,"Depth",0,"Expression",0],[0,"ElementType",1,0],[1,"EndAngle",0,"Expression",0],[0,"Name",1,0],[0,"NumberOfBins",1,0],[1,"Radius",0,"Expression",0],[0,"ReportType",1,0],[0,"Shape",1,0],[0,"ShowVisualization",1,0],[1,"SpringDampers",0,"SelectNXObjectList",0],[1,"StartAngle",0,"Expression",0],[1,"XLength",0,"Expression",0],[1,"YLength",0,"Expression",0],[1,"ZLength",0,"Expression",0]],[],[]];
SPLM.Motion.DiscreteDrivetrainReportBuilder = class extends SPLM.Motion.MotionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.DiscreteDrivetrainReportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.DiscreteDrivetrainReportBuilder.ReportTypeOption = Object.freeze({
    "Span" : "Span", "Spatial" : "Spatial"});

SPLM.Motion.DiscreteDrivetrainReportBuilder.ShapeType = Object.freeze({
    "Box" : "Box", "Cylinder" : "Cylinder"});

SPLM.Motion.DiscreteDrivetrainReportBuilder.ElementTypeOption = Object.freeze({
    "AnalyticalContact" : "AnalyticalContact", "Bushing" : "Bushing", "SpringDamper" : "SpringDamper", "BeamForce" : "BeamForce"});

export default SPLM;